// repository.ts
import { getApiClient } from '@mit/aws-vue';
import { AccountApi } from '@/api/AccountApi';

const accountRepository = getApiClient(AccountApi, 'account@v2');

export default accountRepository;
